import {
  Box,
  Grid,
  Typography,
  IconButton,
  Container,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import Salon_img from "../../assets/img/details_img.png";
import Footer from "../../common/Footer";
import course_img from "../../assets/img/courseImg.png";
import { getInstitute } from "../myInstitute/instituteApi";
import MediaModelApp from "../../common/mediaModelApp";
import AllMediaModelApp from "../Jobs/AllMediaShow";
export const InstituteInfo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [institute, setInstitute] = useState({});
  const [hide, setHide] = useState(false);

  const getData = async () => {
    const payload = { billerId: 0 };

    getInstitute(payload, (res) => {
      const jobList = res?.data?.data?.list || [];
      const selectedJob = jobList.find(
        (item) => String(item.id) === String(id),
      );
      setInstitute(selectedJob);

      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };

  useEffect(() => {
    getData();
  }, [id]);
  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 3, xs: 0 } }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/courses")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          <Container>
            <Box
              sx={{
                backgroundColor: "#FFFFFF",
                borderRadius: "13px",
                p: { xs: 2, sm: 3, md: 4 },
                boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <Box display="flex" justifyContent="center" mb={3}>
                <Grid item xs={12} md={5}>
                  <Box
                    component="img"
                    src={
                      institute?.image2 ||
                      institute?.image3 ||
                      institute?.image4 ||
                      Salon_img
                    }
                    alt="Salon"
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 2,
                      objectFit: "cover",
                    }}
                  />
                </Grid>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  // mb: 3,
                }}
              >
                <Box
                  component="img"
                  src={institute?.image1 || course_img}
                  alt="Institute Logo"
                  sx={{
                    width: { xs: 44, sm: 50, md: 56 },
                    height: { xs: 44, sm: 50, md: 56 },
                    borderRadius: "50%",
                    border: "2px solid #27A42D",
                    padding: "6px",
                    backgroundColor: "#FFFFFF",
                    mr: 2,
                    alignSelf: "stretch",
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Title */}
                  <Typography
                    fontWeight={700}
                    fontSize={{ xs: "20px", sm: "30px", md: "40px" }}
                    lineHeight={1.1}
                  >
                    {institute?.instituteName}
                  </Typography>

                  {/* Social Media Links */}
                  <Box
                    sx={{
                      mt: 1,
                      border: "2px solid #01008B",
                      borderRadius: "10px",
                      px: 2,
                      py: 0.5,
                      width: "fit-content",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setHide(true);
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#01008B",
                      }}
                    >
                      Social Media Links
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Address */}
              <Grid container spacing={4} py={5}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // gap={{ xs: 5, sm: 0 }}
                    borderBottom="1px solid #ccc"
                    py={1}
                  >
                    <Typography
                      color="#000"
                      fontWeight="600"
                      sx={{
                        fontSize: { xs: 13, sm: 14 },
                      }}
                    >
                      Address :
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, sm: 13, md: 14 },
                        textAlign: "right",
                      }}
                    >
                      {institute?.briefAddress}
                    </Typography>
                  </Box>
                </Grid>

                {[
                  ["Branch Name", institute?.branchName],
                  ["District", institute?.district],
                  ["City", institute?.city],
                  ["State", institute?.state],
                  ["Pin code", institute?.pincode],
                  ["Mobile Number 1", institute?.mobileNumber1],
                  ["Mobile Number 2", institute?.mobileNumber2],
                  ["Whatsapp Mobile Number", institute?.whatsappNumber],
                  ["Mail ID 1", institute?.emailId1],
                  ["Mail ID 2", institute?.emailId2],
                ].map(([label, value], index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      borderBottom="1px solid #ccc"
                    >
                      <Typography
                        fontWeight={600}
                        fontSize={{ xs: 13, sm: 14 }}
                      >
                        {label} :
                      </Typography>
                      <Typography fontSize={{ xs: 13, sm: 14 }}>
                        {value || "_"}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Container>
          <AllMediaModelApp
            open={hide}
            setOpen={setHide}
            modelData={{
              google: "",
              website: "",
              instagram: "",
              facebook: "",
              youTube: "",
              pinterest: "",
              twitter: "",
              linkedIn: "",
              ...institute,
            }}
            // setModalData={setMyBussinessData}
          />
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
};
